<template>
  <div class="finance">
    <div class="fz14 bold fr ac jsb">
      <span>财务管理</span>
    </div>

    <div class="mt30">
      <el-tabs v-model="tab">
        <el-tab-pane label="产品订单" name="1"></el-tab-pane>
        <el-tab-pane label="服务订单" name="2"></el-tab-pane>
        <el-tab-pane label="售后订单" name="3"></el-tab-pane>
      </el-tabs>
      <order v-show="tab === '1'"/>
      <service v-show="tab === '2'"/>
      <refund v-show="tab === '3'"/>
    </div>
  </div>
</template>

<script>
import order from "./components/order";
import service from "./components/service";
import refund from "./components/refund";

export default {
  props: {},
  data() {
    return {
      tab: "1",
      order_state: "",
      page: 1,
      total: 20,
      service_list: [],
    };
  },
  methods: {
    getOrders() {
      this.post("orderInterfaces/v1.0/getOrders", {
        page: this.page,
        order_state: "3,4,5,6,7",
        pay_state: "0,1,2",
      }).then((res) => {
        this.service_list = res.data;
        this.total = res.total;
      });
    },
    getServiceOrders() {
      this.post("serviceInterfaces/v1.0/getServiceOrders", {
        page: this.page,
        order_state: "3",
      }).then((res) => {
        this.total = res.total;
        this.service_list = res.data;
      });
    },
    getOrderRefunds() {
      this.post("orderInterfaces/v1.0/getOrderRefunds", {
        page: this.page,
        order_state: "3",
      }).then((res) => {
        this.total = res.total;
        this.service_list = res.data;
      });
    },
  },
  components: {order, service, refund},
};
</script>

<style scoped lang="scss">
.finance {
  .service_box {
    background-color: #fff;

    .order_list_item {
      &:nth-of-type(1) {
        width: 260px;
      }

      width: 175px;
    }

    .order-list {
      .order-item {
        border: 1px solid #e5e5e5;

        .order_list_item {
          border-right: 1px solid #e5e5e5;

          &:nth-of-type(4) {
            border-right: none;
          }
        }

        .top {
          background-color: #f0f6ff;
          padding: 14px;
        }

        .middle {
          .order {
            .order_left {
              min-height: 80px;
              border-right: 1px solid #e5e5e5;
              border-bottom: 1px solid #e5e5e5;

              &:last-child {
                border-bottom: none;
              }

              .goods_img {
                width: 80px;
                height: 80px;
              }
            }

            .operating {
              .el-button {
                font-weight: normal;
              }

              p {
                margin-top: 10px;

                &:nth-of-type(1) {
                  margin-top: 0;
                }
              }
            }
          }
        }
      }
    }
  }

  .order_box {
    background-color: #fff;

    .order_list_item {
      &:nth-of-type(1) {
        width: 270px;
      }

      &:nth-of-type(2) {
        width: 88px;
      }

      &:nth-of-type(3) {
        width: 110px;
      }

      &:nth-of-type(4) {
        width: 88px;
      }

      &:nth-of-type(5) {
        width: 88px;
      }

      &:nth-of-type(6) {
        width: 88px;
      }

      &:nth-of-type(7) {
        width: 88px;
      }
    }

    .order-list {
      .order-item {
        border: 1px solid #e5e5e5;

        .top {
          background-color: #f0f6ff;
          padding: 14px;
        }

        .middle {
          border-bottom: 1px solid #e5e5e5;

          .order {
            .order_left {
              border-right: 1px solid #e5e5e5;
              border-bottom: 1px solid #e5e5e5;

              &:last-child {
                border-bottom: none;
              }

              .goods_img {
                width: 80px;
                height: 80px;
              }
            }

            .operating {
              p {
                margin-top: 10px;

                &:nth-of-type(1) {
                  margin-top: 0;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/me/finance/index.vue